<!-- 
** jpv: bouton infos de la barre de boutons de droite
-->
<template>
	<div class="infos tooltip is-tooltip-left" :data-tooltip="tooltip" @click="infos()">
		<infos-icon/>
	</div>

	<!--
	<div class="info">
                <div class="sticky-close">
                        <div class="close" @click="$emit('close')">
                                <close-icon/>
                        </div>
                </div>
		
                <section class="content">

                        <Share :url="shareUrl"/>
                        <h3>Qu’est-ce que cette carte&nbsp;?</h3>
                        <p>Cette carte met en parallèle la pollution de l’air extérieure au dioxyde d’azote (NO$
                        <p>La norme européenne à ne pas dépasser est fixée à 40&nbsp;µg/m<sup>3</sup> pour le d$
                        <p>C’est pourquoi nous avons voulu mettre en avant cette donnée afin que les élus locau$

                        <h3>Que signifient les résultats ?</h3>
                        <p><em class="level level-1">C’est bien</em> : le niveau de pollution au dioxyde d’azot$
                        <p><em class="level level-2">Qualité de l’air moyenne</em> : le niveau de pollution au $
                        <p><em class="level level-3">Qualité de l’air mauvaise</em> : le niveau de pollution au$
                        <p><em class="level level-4">Inacceptable et illégal</em> : le niveau de pollution au d$
                        <p>Nous ne prenons en compte ici que la pollution au dioxyde d'azote, mais les concentr$

                        <h3>Qu’est-ce que le dioxyde d’azote (NO<sub>2</sub>)&nbsp;?</h3>
                        <p>Le dioxyde d’azote est un des principaux polluants atmosphériques nocifs pour la san$
                        <p>En France, les émissions d’oxydes d’azote proviennent surtout du secteur des transpo$

                        <h3>Méthodologie : comment avons-nous procédé&nbsp;?</h3>
                        <p>Nous avons utilisé des cartes de pollution de l’air fournies par les <a href="https:$
                        <p>Les enfants sont particulièrement vulnérables face à la pollution de l’air. Afin d’é$
                        <p>Les localisations des écoles maternelles et primaires nous ont été fournies par le m$
                        <p v-if="ville.info.label === 'lyon'">Les données concernant les établissements d’accue$
                        <p v-if=" ville.info.label === 'marseille'">Les données concernant les établissements d$
                        <p v-if=" ville.info.label === 'strasbourg'">Les données concernant les établissements $
                        <p>L’intégralité de nos données <a :href="dataUrl" target="_blank">sont disponibles ici$
                        <p>Pour en savoir plus, <a :href="ville.info.blogUrl" target="_blank">suivez ce lien</a$

                        <h3>Nous contacter</h3>
                        <p>Si vous avez noté une erreur concernant la localisation d’un établissement ou si vou$
                        <p class="mentions-legales">
                                <a href="https://www.greenpeace.fr/mentions-legales/" target="_blank">Mentions $
                                <span @click="$emit('close')">Fermer</span>
                        </p>
                </section>
		
	</div>
	-->
</template>

<script>
import InfosIcon from './icons/help.svg'
import CloseIcon from './icons/croix-fermer.svg';
import tooltips from '@texts/tooltips.json'

export default {
	name: 'Infos',
	components: {
		InfosIcon,
		CloseIcon,
	},
	data() {
		return {
			tooltip: tooltips.infos
		}
	},
	methods: {
		infos() {
			/*let elm = document.documentElement

			if (elm.requestFullscreen) {
				elm.requestFullscreen()
			}
			else if (elm.mozRequestFullScreen) {
				elm.mozRequestFullScreen()
			}
			else if (elm.webkitRequestFullScreen) {
				elm.webkitRequestFullScreen()
			}*/
			window.open("https://www.greenpeace.fr/informations-sur-la-carte-des-dechets-nucleaires", "_blank");
		}
	}

}
</script>


<style scoped lang="scss">

.infos {
	@extend %base-btn;

	background-color: #fff;
	width: 34px;
	height: 34px;
	padding: 8px;
	margin: 8px 6px;

	svg {
		max-width: 17px;
		> * {
			fill: $noir;
		}
	}

}

</style>
